(function() {

	function updateTextNumberPosition () {
		Array.from(document.querySelectorAll('.text-numbering-headline-holder, .text-copy-normal, .text-copy-small')).forEach(function(item) {
			var number = item.querySelector('.text-numbering');
			var headline = item.querySelector('.text-numbering-content h3:first-child');
			if(headline && number) {
				var height = (headline.offsetHeight > 0) ? (headline.offsetHeight + 'px') : false;
				if(window.innerWidth < 576) {
					height = false;
				}
				number.style.height = height || 'auto';
				number.style.lineHeight = height || 'initial';
			}
		});
	}

	window.addEventListener('resize', updateTextNumberPosition);
	updateTextNumberPosition();
}());
